module.exports = "https://www.gc-pro.gnp.com.mx/3ea1e72456041fb25f16fc6c06a6a767.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/datos_activo.svg
// module id = 963
// module chunks = 0